import enGB from 'antd/lib/locale-provider/en_GB'
import esES from 'antd/lib/locale-provider/es_ES'
import { getI18n } from 'react-i18next'

export const getLocale = () => {
  const I18nLocale = getI18n().language
  switch (I18nLocale) {
    case 'es-ES':
      return esES
    case 'en-GB':
      return enGB
    default:
      return enGB
  }
}
